import React, { Component } from "react";
import { reduxForm, formValueSelector } from "redux-form";
import { push, replace } from "react-router-redux";
import { connect } from "react-redux";
import Input from "../../../../components/form/Input";
import Password from "../../../../components/form/Password";
import Button from "../../../../components/form/Button";
import CroField from "../../components/generalForm/CroField";
import CroSubhead from "../../components/generalForm/CroSubhead";
import { OfficialsLegitimate, OfficialsInInitiative as OfficialGrid } from "../grids/OfficialGrid";
import { generateLogin } from "../../CroActions";
import { isOfficialAdmin, isAdmin } from "../../CroUtils";
import { togglePanel } from "../../../../actions/appActions";
import { styles } from "../../index";
import { asyncForm } from "../../../../utils/asyncForm";
import * as V from "../../../../utils/formValidation";
import askAction from "../AskAction";
import {ReduxCheckbox as Checkbox} from "../../../../components/form/Checkbox";

const minLength8 = V.minLength(8);

const selector = formValueSelector("legitimateForm");

class LegitimateForm extends Component {  
  componentWillMount() {
    this.props.breadcrumbs(this.props.breadcrumbsItems);
  }

  generateLogin = (data) => async () => {
    const { change, dispatch } = this.props;
    const { username, password } = await generateLogin(
      "/spravce/api/opravnene-organy/prihlasovaci-udaje/generovat",
      dispatch,
      data,
    );

    change("username", username);
    change("plainPassword", password);
  };

  disableGen = () => {
    const { name } = this.props.loginData;
    return !name;
  };

  onOfficialClick = (startUrl) => ({ id }) => {
    this.props.dispatch(
      push(`${startUrl}/funkcionari/form/${id}`),
    );
  };

  showSelectOfficials = () => {
    const { dispatch, location } = this.props;
    dispatch(push({ pathname: location.pathname, query: { q: "funkcionar" } }));
  };

  officialSelected = (official) => {
    const { dispatch, location, change, officials } = this.props;

    if (official) {
      if (officials.find(o => o.id === official.id)) {
        dispatch(togglePanel("Přístup k vybranému funkcionáři již existuje"));
        return;
      }

      const updated = [...(officials || []), official];
      change("officials", updated);
    }
    dispatch(replace({ pathname: location.pathname }))
  };

  officialsSelected = (ids, selectedOfficials) => {
    const { dispatch, location, change, officials } = this.props;

    if (selectedOfficials && selectedOfficials.length) {
      const existing = selectedOfficials.filter(o => officials.find(of => of.id === o.id));
      if (existing.length) {
        dispatch(togglePanel("Přístup k některým funkcionářům již existuje"));
      }

      const updated = [...(officials || []), ...selectedOfficials];
      change("officials", updated);
    }
    dispatch(replace({ pathname: location.pathname }))
  };

  cancelOfficialSelect = () => {
    const { dispatch, location } = this.props;
    dispatch(replace({ pathname: location.pathname }))
  };

  unassignOfficial = (selectedOfficials) => {
    const { officials, change } = this.props;
    const updated = (officials || []).filter(o => !selectedOfficials.includes(o.id));
    change("officials", updated);
  }

  render() {
    const {
      auth,
      error,
      onDelete,
      onSubmit,
      handleSubmit,
      submitting,
      disabled,
      loginData,
      askAction,
      isNew,
      canDelete,
      officials,
      allOfficials,
      location: { query }
    } = this.props;

    if (query.q === "funkcionar") {
      return (
        <div>
          <OfficialGrid
            url={`${auth.startUrl}/api/funkcionari`}
            onRowClick={this.officialSelected}
            allowCheck={true}
            moreCheckboxFns={true}
            fnText="Přidat označené"
            onCheckboxFn={this.officialsSelected}
            gridName="officialsGrid_initial"
          />
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            onClick={this.cancelOfficialSelect}
          />
        </div>
      );
    }

    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="cro-form long-label legitimateForm"
      >
        <div className="legitimateForm__section legitimateForm__fullWidth">
          <div className="legitimateForm__grid">
            <CroField
                className="half compact-input"
                title="IČO"
                name="ic"
                component={Input}
                fullWidth
                disabled={disabled}
            />
            <CroField
              className="half compact-input"
              title="Název"
              name="name"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.required]}
            />
            <CroField
              className="half"
              title="Přihlašovací jméno"
              name="username"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.required]}
            />
            <CroField
              className="half"
              title="Heslo"
              name="plainPassword"
              component={Password}
              fullWidth
              disabled={disabled}
              validate={[minLength8]}
            />
          </div>
        </div>

        <div className="legitimateForm__section legitimateForm__fullWidth">
          <CroField
            title="Důvod vytvoření"
            name="createNote"
            component={Input}
            multiline
            rows={3}
            fullWidth
            disabled={disabled || !isNew}
          />
        </div>

        <div className="legitimateForm__section legitimateForm__fullWidth">
          <div className="legitimateForm__grid">
            <CroField
              title="Přístup na všechny funkcionáře"
              name="allOfficials"
              component={Checkbox}
              disabled={disabled || !isOfficialAdmin(auth)}
            />
          </div>
        </div>

        {(isOfficialAdmin(auth) || isAdmin(auth)) && !isNew && !allOfficials && (
          <div className="legitimateForm__section legitimateForm__fullWidth">
            <div className="legitimateForm__officialsGrid">
              <CroSubhead title="Přístup k veřejným funkcionářům" />
              <OfficialsLegitimate 
                gridName="legitimateOfficialsGrid"
                items={officials}
                count={officials?.length || 0}
                showPaging={true}
                pageSize={10}
                filtering={false}
                allowCheck={true}
                adding={true}
                onAdd={this.showSelectOfficials}
                moreCheckboxFns={true}
                fnText="Odebrat přístup"
                onCheckboxFn={this.unassignOfficial}
                onRowClick={this.onOfficialClick(auth.startUrl)}
              />
            </div>
          </div>
        )}

        {!disabled && (
          <div className="legitimateForm__footer">
            <div className="legitimateForm__footerInner">
              {error && <div className="error">{error}</div>}
              {!this.props.valid && this.props.submitFailed && !error && (
                <div className="error">
                  Povinná pole nejsou správně vyplněna.
                </div>
              )}
              <div className="legitimateForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>

              <div className="legitimateForm__actions">
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Uložit"
                  disabled={submitting || disabled}
                  onClick={handleSubmit(onSubmit)}
                />
                {!isNew && canDelete && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Smazat"
                    disabled={submitting || disabled}
                    onClick={askAction(
                      onDelete,
                      "Opravdu chcete smazat oprávněný orgán?",
                        true
                    )}
                  />
                )}
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Generovat jméno a heslo"
                  disabled={submitting || disabled || this.disableGen()}
                  onClick={this.generateLogin(loginData)}
                />
                {this.props.onShowHistory && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zobrazit historii"
                    onClick={this.props.onShowHistory}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </form>
    );
  }
}

export default connect((state) => ({
  officialToAssign: selector(state, "officialToAssign__form"),
}))(reduxForm({
  form: "legitimateForm",
  initialValues: { allowBasic: true },
})(askAction(asyncForm(LegitimateForm))));
